import React from "react";
const WelcomeSEP = ({ data }) => {
    return (
        <div className="w-full mx-auto max-w-7xl lg:max-w-7xl xs:max-w-[80%] 2xl:max-w-6xl pt-24 pb-10 2xl:pt-32">
            <div className="relative grid grid-cols-[33%_67%] xs:grid-cols-1 2xl:grid-cols-[33%_65%]">
                <div className="flex flex-col justify-start pt-4 max-w-md xs:px-4 items-start  gap-y-1 lg:pl-12 xs:pl-0">
                    {data.title && (
                        <h1 className="text-6xl leading-tight xs:text-3xl 2xl:text-4xl 2xl:leading-tight">{data.title}</h1>
                    )}
                    {data.subheading && <p className="text-2xl pt-1 2xl:text-lg text-[#767676]">{data.subheading}</p>}
                </div>
                <div className="flex h-full max-w-7xl pl-20  xs:w-full xs:px-24 gap-3 items-start 2xl:px-4 xs:pl-0 xs:max-w-[80%]">
                    {data.primaryImg && (
                        <img
                            className="w-full h-full object-contain"
                            src={data.primaryImg}
                            alt="Primary"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default WelcomeSEP;
